import * as Dialog from "@radix-ui/react-dialog";
import { Menu, X } from "lucide-react";
import { NavLink } from "react-router-dom";

import { AppLogo } from "@/components/navigation/app-logo";
import { Button } from "@/components/ui/button";
import { navigationSections } from "@/lib/navigation";
import { cn } from "@/lib/utils";

export function MobileNav() {
  return (
    <Dialog.Root>
      <Dialog.Trigger asChild>
        <Button variant="outline" size="icon" className="lg:hidden" aria-label="Buka navigasi">
          <Menu className="size-4" />
        </Button>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-slate-950/50 backdrop-blur-sm" />
        <Dialog.Content className="fixed inset-y-0 left-0 z-50 w-[88vw] max-w-sm border-r border-border bg-card p-5 shadow-panel">
          <div className="flex items-center justify-between">
            <AppLogo />
            <Dialog.Close asChild>
              <Button variant="ghost" size="icon" aria-label="Tutup navigasi">
                <X className="size-4" />
              </Button>
            </Dialog.Close>
          </div>

          <div className="mt-8 space-y-6">
            {navigationSections.map((section) => (
              <div key={section.title}>
                <p className="px-3 text-[11px] font-semibold uppercase tracking-[0.22em] text-muted-foreground/80">
                  {section.title}
                </p>
                <div className="mt-2 space-y-2">
                  {section.items.map((item) => {
                    const Icon = item.icon;
                    return (
                      <Dialog.Close asChild key={item.path}>
                        <NavLink
                          className={({ isActive }) =>
                            cn(
                              "flex items-center gap-3 rounded-xl px-3 py-3 transition",
                              isActive
                                ? "bg-fiscal text-fiscal-foreground"
                                : "text-muted-foreground hover:bg-accent hover:text-foreground",
                            )
                          }
                          to={item.path}
                        >
                          <Icon className="size-5 shrink-0" />
                          <div>
                            <div className="font-semibold">{item.title}</div>
                            <div className="mt-1 text-xs opacity-75">{item.description}</div>
                          </div>
                        </NavLink>
                      </Dialog.Close>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
